module.exports = __webpack_public_path__ + "img/hola_bonita_logo.429e39c9.png";